import type { ToastProps } from "@gravity-ui/uikit";
import { Toaster } from "@gravity-ui/uikit";
import { POIZON_API_SUPPORT_LINK } from "src/constants/links";

export const toaster = new Toaster();

const options: Pick<ToastProps, "isClosable" | "autoHiding"> = {
  isClosable: true,
  autoHiding: 10000,
};
export const toastHandler = {
  warning: (props: Omit<ToastProps, "type">) =>
    toaster.add({
      ...props,
      ...options,
      theme: "warning",
    }),
  error: (props: Omit<ToastProps, "type">) =>
    toaster.add({
      ...props,
      ...options,
      theme: "danger",
      actions: [
        {
          onClick: () => {
            window.open(POIZON_API_SUPPORT_LINK, "_blank")?.focus();
          },
          label: "Обратиться в поддержку",
          view: "flat-danger",
        },
      ],
    }),
  info: (props: Omit<ToastProps, "type">) =>
    toaster.add({
      ...props,
      ...options,
      theme: "info",
    }),
  success: (props: Omit<ToastProps, "type">) =>
    toaster.add({
      ...props,
      ...options,
      theme: "success",
    }),
  utility: (props: Omit<ToastProps, "type">) =>
    toaster.add({
      ...props,
      ...options,
      theme: "utility",
    }),
};
